import UserProfileModule from "@/modules/UserProfile";

function UserProfilePage() {
  return <UserProfileModule type="view" />;
}

export default UserProfilePage;
